import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { HeartPulseIcon, XIcon } from 'lucide-react';
import { PURCHASE_ANCHOR, popupSales } from '../data/content';
export function SalesPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const cycle = (i: number) => {
      timeout = setTimeout(() => {
        setIndex(i % popupSales.length);
        setVisible(true);
        timeout = setTimeout(() => {
          setVisible(false);
          cycle(i + 1);
        }, 5200);
      }, 3200);
    };
    cycle(0);
    return () => clearTimeout(timeout);
  }, [dismissed]);
  const sale = popupSales[index];
  const y = reduceMotion ? 0 : 14;
  return <AnimatePresence data-id="element-129" data-mp="18rdm0751wm2b">
      {visible && !dismissed ? <motion.aside initial={{
      opacity: 0,
      y,
      scale: reduceMotion ? 1 : 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y,
      scale: reduceMotion ? 1 : 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-2 left-2 z-50 w-[15rem] overflow-hidden rounded-lg border-2 border-teal bg-white shadow-[0_8px_22px_-6px_rgba(8,127,140,0.6)] ring-2 ring-teal-light/60 sm:w-[17rem]" aria-live="polite" data-id="element-130" data-mp="1zs4ntfqcqhuc">
          <div className="flex items-center gap-1.5 bg-teal px-2 py-1" data-id="element-131" data-mp="2ng5raa8ob82w">
            <HeartPulseIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-132" data-mp="2sgjqd2sar7os" />
            <p className="font-heading text-[0.56rem] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-133" data-mp="2xfd48wbhx0ph">
              New purchase verified
            </p>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="ml-auto text-white/80 transition-colors duration-150 ease-out hover:text-white" data-id="element-134" data-mp="y3tuifidboer">
              <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-135" data-mp="q233yerzay7h" />
            </button>
          </div>
          <a href={PURCHASE_ANCHOR} className="block border-l-4 border-burgundy px-2 py-1.5" data-id="element-136" data-mp="14zdb5bxl9hxe">
            <p className="text-[0.72rem] font-bold leading-tight text-navy" data-id="element-137" data-mp="zz7qifpqkvot">
              {sale.name} just bought CARDIOLOGY VISUAL ATLAS™
            </p>
            <p className="mt-0.5 text-[0.62rem] font-semibold text-ink/80" data-id="element-138" data-mp="1dxfh85w6j0rj">
              {sale.city}, {sale.country} • a few minutes ago
            </p>
          </a>
        </motion.aside> : null}
    </AnimatePresence>;
}